/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_Decline_DescInputs */

const en_privacy_section_4_decline_desc = /** @type {(inputs: Privacy_Section_4_Decline_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`only essential functionality is maintained. Your preference is stored locally in your browser`)
};

const lv_privacy_section_4_decline_desc = /** @type {(inputs: Privacy_Section_4_Decline_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tiek nodrošināta tikai nepieciešamā funkcionalitāte. Jūsu izvēle tiek glabāta lokāli Jūsu pārlūkā`)
};

/**
* | output |
* | --- |
* | "only essential functionality is maintained. Your preference is stored locally in your browser" |
*
* @param {Privacy_Section_4_Decline_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_decline_desc = /** @type {((inputs?: Privacy_Section_4_Decline_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_Decline_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_decline_desc(inputs)
	return en_privacy_section_4_decline_desc(inputs)
});